function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.6668 0.666748H2.66683C1.9335 0.666748 1.3335 1.26675 1.3335 2.00008V11.3334H2.66683V2.00008H10.6668V0.666748ZM10.0002 3.33341L14.0002 7.33341V14.0001C14.0002 14.7334 13.4002 15.3334 12.6668 15.3334H5.32683C4.5935 15.3334 4.00016 14.7334 4.00016 14.0001L4.00683 4.66675C4.00683 3.93341 4.60016 3.33341 5.3335 3.33341H10.0002ZM9.3335 8.00008H13.0002L9.3335 4.33341V8.00008Z",
  fill: "#0078FF"
});

const SvgCopyicon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopyicon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.icon.835ebda7.svg";
export { ForwardRef as ReactComponent };